import { render, staticRenderFns } from "./nav-page-edit-modal.vue?vue&type=template&id=a5636318&scoped=true&"
import script from "./nav-page-edit-modal.vue?vue&type=script&lang=ts&"
export * from "./nav-page-edit-modal.vue?vue&type=script&lang=ts&"
import style0 from "./nav-page-edit-modal.vue?vue&type=style&index=0&id=a5636318&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5636318",
  null
  
)

export default component.exports